import { useSelector } from 'react-redux';

import { selectQuotationReasonOptions } from '../services/selectors';

export const useQuotationReasonOptions = () => useSelector(selectQuotationReasonOptions);
